<template>
  <g>
    <ellipse cx="10" cy="4.875" rx="6.25" ry="1.875" stroke="currentColor" stroke-width="1.5"/>
    <path d="M16.25 4.875L14.6875 16.75C14.25 18 12.5 18.625 10 18.625C7.5 18.625 5.8125 18 5.3125 16.75L3.75 4.875" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
</template>
